var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M29.3333 0H2.66667C1.19391 0 0 1.19391 0 2.66667V29.3333C0 30.8061 1.19391 32 2.66667 32H29.3333C30.8061 32 32 30.8061 32 29.3333V2.66667C32 1.19391 30.8061 0 29.3333 0Z",
    fill: "#5E64AA"
  }), /*#__PURE__*/React.createElement("g", {
    id: "menu"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M1.77734 9.61805V22.3825C1.79068 23.5825 2.43957 24.6892 3.48401 25.2803L14.1507 31.5025C15.2929 32.1692 16.7062 32.1692 17.8485 31.5025L28.5151 25.2803C29.5596 24.6892 30.2085 23.5825 30.2218 22.3825V9.61805C30.2085 8.41805 29.5596 7.31138 28.5151 6.72027L17.8485 0.498047C16.7062 -0.16862 15.2929 -0.16862 14.1507 0.498047L3.48401 6.72027C2.43957 7.31138 1.79068 8.41805 1.77734 9.61805Z",
    fill: "#5E64AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M23.6249 22.222H7.99826C7.50938 22.222 7.10938 21.822 7.10938 21.3331V9.77756C7.10938 9.28867 7.50938 8.88867 7.99826 8.88867C8.48715 8.88867 8.88715 9.28867 8.88715 9.77756V20.4442H23.6249C24.1138 20.4442 24.5138 20.8442 24.5138 21.3331C24.5138 21.822 24.1138 22.222 23.6249 22.222Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M24.8869 23.1111H21.3313C20.5446 23.1422 19.8246 22.6578 19.5535 21.92C19.2291 20.9955 19.7135 19.9778 20.6424 19.6533C20.8646 19.5733 21.1002 19.5422 21.3313 19.5555H23.1091V13.5555L17.1891 17.8311C16.5535 18.3111 15.6824 18.3111 15.0469 17.8311L6.93131 11.3867C6.14908 10.7867 5.99797 9.66665 6.59797 8.88443C7.19797 8.10221 8.31797 7.9511 9.1002 8.5511L16.2113 14.1511L23.758 8.70221C24.518 8.07999 25.638 8.18665 26.2602 8.94665C26.518 9.26221 26.6602 9.65332 26.6646 10.0622V21.3333C26.6646 22.3155 25.8691 23.1111 24.8869 23.1111Z",
    fill: "#5E64AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M24.8894 22.2227H21.3338C20.8449 22.2227 20.4449 21.8227 20.4449 21.3339C20.4449 20.845 20.8449 20.445 21.3338 20.445H24.0005V11.805L16.6138 17.1383C16.2938 17.3872 15.8405 17.3872 15.5205 17.1383L7.28049 10.6672C6.88493 10.3783 6.79605 9.82275 7.08049 9.42719C7.08938 9.41386 7.09827 9.40053 7.1116 9.38719C7.41382 9.00053 7.97382 8.93386 8.36049 9.23608C8.36938 9.24053 8.37827 9.24942 8.38271 9.25386L16.0538 15.2716L24.2227 9.41386C24.5116 9.16497 24.9205 9.10719 25.2627 9.27164C25.5605 9.42275 25.7516 9.72942 25.7516 10.0627L25.7783 21.3339C25.7783 21.5694 25.6849 21.7961 25.5205 21.965C25.3516 22.125 25.1249 22.2183 24.8894 22.2227Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M8.6584 10.7554C8.31173 10.7643 7.96507 10.7021 7.64507 10.5688C7.35618 10.4088 7.18284 10.0977 7.19173 9.76877C7.19173 9.27988 7.59173 8.87988 8.08062 8.87988H24.7117C25.2006 8.87988 25.6006 9.27988 25.6006 9.76877C25.6006 10.2577 25.2006 10.6577 24.7117 10.6577H9.25395C9.06284 10.7243 8.86284 10.7599 8.6584 10.7554ZM8.88951 9.77766H8.99618C8.99618 9.63099 8.95618 9.48433 8.88951 9.35099V9.77766Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/Email.1ed75bc2068e276e6391ba47b788412e.svg";
export { ForwardRef as ReactComponent };